import classNames from 'classnames';
import { PropTypes as MobxPropTypes, observer } from 'mobx-react';
import React from 'react';

import PropTypes from 'prop-types';
import OrderTotalClass from '../../../types/order/OrderTotalClass';

const OrderTotals = ({ totals }) => {
  const renderTotals = [];

  totals.forEach((total) => {
    renderTotals.push(
      <div key={total.class} className="OrderTotals__row">
        <div
          key={total.class}
          className={classNames('OrderTotals__name', {
            OrderTotals__bold: total.class === OrderTotalClass.TOTAL,
          })}
        >
          {total.name}
        </div>
        <div
          className={classNames('OrderTotals__price', {
            OrderTotals__bold: total.class === OrderTotalClass.TOTAL,
            OrderTotals__discount:
              total.class === OrderTotalClass.CAMPAIGN_CODE_DISCOUNT,
          })}
        >
          {total.text}
        </div>
      </div>
    );
  });

  return (
    (renderTotals.length > 0 && (
      <div className="OrderTotals">{renderTotals}</div>
    )) ||
    null
  );
};

OrderTotals.propTypes = {
  totals: PropTypes.oneOfType([MobxPropTypes.observableArray, PropTypes.array])
    .isRequired,
};

export default observer(OrderTotals);
